@if (languageChange$ | async; as _lang) {
  <ng-container *transloco="let t">
    <!-- begin:: Container -->
    <div class="container footer mt-4 py-5 rounded-top">
      <!-- begin:: footer link -->
      <div class="row footer-links">
        <!-- begin:: Col-1 -->
        <div class="col-md-2 col-xs-12">
          <!-- begin:: Search parts -->
          <section>
            <h5 class="text-white">
              <i class="fa fa-search text-white me-2"></i>
              <span transloco="label_search_parts"></span>
            </h5>
            <ul>
              <li>
                <a [title]="t('label_car_parts')" [routerLink]="['/', _lang, 'pb', t('label_search') | makemepretty, t('label_type') | makemepretty]" transloco="label_car_parts"> </a>
              </li>
              <li>
                <a [title]="t('label_truck_parts')" [routerLink]="['/', _lang, 'ov', t('label_search') | makemepretty, t('label_type') | makemepretty, t('label_other') | makemepretty]" [queryParams]="{ vc2: '107' }" transloco="label_truck_parts">
                </a>
              </li>
              <li>
                <a
                  [title]="t('label_motorcycle_and_scooter_parts')"
                  [routerLink]="['/', _lang, 'ov', t('label_search') | makemepretty, t('label_type') | makemepretty, t('label_other') | makemepretty]"
                  [queryParams]="{ vc2: '105' }"
                  transloco="label_motorcycle_and_scooter_parts"
                >
                </a>
              </li>
              <li>
                <a
                  [title]="t('label_motorhome_and_caravan')"
                  [routerLink]="['/', _lang, 'ov', t('label_search') | makemepretty, t('label_type') | makemepretty, t('label_other') | makemepretty]"
                  [queryParams]="{ vc2: '104' }"
                  transloco="label_motorhome_and_caravan"
                >
                </a>
              </li>
              <li>
                <a [title]="t('label_snowmobile')" [routerLink]="['/', _lang, 'ov', t('label_search') | makemepretty, t('label_type') | makemepretty, t('label_other') | makemepretty]" [queryParams]="{ vc2: '106' }" transloco="label_snowmobile"></a>
              </li>
              <li>
                <a [routerLink]="['pb', t('label_search') | makemepretty, t('label_type') | makemepretty, 's1', t('label_other') | makemepretty]" [queryParams]="{ vc2: '102' }" [title]="t('label_tyres_and_rims')" transloco="label_tyres_and_rims"></a>
              </li>
              <li>
                <a [title]="t('label_other')" [routerLink]="['/', _lang, 'pb', t('label_search') | makemepretty, t('label_type') | makemepretty, 's1', t('label_other') | makemepretty]" transloco="label_other"></a>
              </li>
              <li>
                <a [title]="t('label_search_unattached_part')" [routerLink]="['/', _lang, 'pb', t('label_search') | makemepretty, t('label_type') | makemepretty, 's9', 'AP']" transloco="label_search_unattached_part"> </a>
              </li>
            </ul>
          </section>
          <!-- end:: Search parts -->
          <!-- begin:: Search -->
          <section>
            <h5 class="text-white">
              <i class="fa fa-list text-white me-2"></i>
              <span transloco="label_search"></span>
            </h5>
            <ul>
              <li>
                <a [title]="t('label_registration_number_search')" [routerLink]="['/', _lang, 'pb', t('label_search') | makemepretty, t('label_type') | makemepretty, 's2', 'Regnr']" transloco="label_registration_number_search"> </a>
              </li>
            </ul>
          </section>
          <!-- end:: Search -->
        </div>
        <!-- end:: Col-1 -->

        <!-- begin:: Col-2 -->
        <div class="col-md-2 col-xs-12">
          <!-- begin:: Workshop -->
          <section>
            <h5 class="text-white">
              <i class="fa fa-wrench text-white me-2"></i>
              <span transloco="label_workshop"></span>
            </h5>
            <ul>
              <li>
                <a [title]="t('label_workshop_send_damage_calculations')" [routerLink]="['/', _lang, 'documents', t('label_url_workshop_send_damage_calculations')]" transloco="label_workshop_send_damage_calculations"> </a>
              </li>
              <li>
                <a [title]="t('label_b2b_agreement')" [routerLink]="['/', _lang, 'documents', t('label_url_b2b_agreement')]" transloco="label_b2b_agreement"> </a>
              </li>
            </ul>
          </section>
          <!-- end:: Workshop -->

          <!-- begin:: Order -->
          <section>
            <h5 class="text-white">
              <i class="fa fa-shopping-cart text-white me-2"></i>
              <span transloco="label_order"></span>
            </h5>
            <ul>
              <li>
                <a [title]="t('label_my_page')" [routerLink]="['/', _lang, 'account', 'orders', 'subject', 'all']" transloco="label_my_page"> </a>
              </li>
              <li>
                <a [routerLink]="['/', _lang, 'right-of-withdrawal']" transloco="label_right_of_withdrawal"></a>
              </li>
            </ul>
          </section>
          <!-- end:: Order -->

          <!-- begin:: Insurance company -->
          <section>
            <h5 class="text-white">
              <i class="bi bi-shield-fill-check text-white me-2"></i>
              <span transloco="label_insurance_company"></span>
            </h5>
            <ul>
              <li>
               <a [title]="t('label_services_insurance_companies')" [routerLink]="['/', _lang, 'documents', t('label_url_information_to_insurance_companies')]" transloco="label_services_insurance_companies"> </a>
              </li>
            </ul>
          </section>
          <!-- end:: Insurance company -->
        </div>
        <!-- end:: Col-2 -->

        <!-- begin:: Col-3 -->
        <div class="col-md-2 col-xs-12">
          <!-- begin:: Help -->
          <section>
            <h5 class="text-white">
              <i class="fa fa-question-circle text-white me-2"></i>
              <span transloco="label_help"></span>
            </h5>
            <ul>
              <li>
                <a [title]="t('label_how_you_search')" [routerLink]="['/', _lang, 'documents', t('label_url_how_you_search')]" transloco="label_how_you_search"> </a>
              </li>
              <li>
                <a [title]="t('label_buying_car_parts')" [routerLink]="['/', _lang, 'documents', t('label_url_buying_car_parts')]" transloco="label_buying_car_parts"> </a>
              </li>
              <li>
                <a [title]="t('label_quality_codes')" [routerLink]="['/', _lang, 'documents', t('label_url_quality_codes')]" transloco="label_quality_codes"> </a>
              </li>
              <li>
                <a [title]="t('label_guarantee')" [routerLink]="['/', _lang, 'documents', t('label_url_guarantee')]" transloco="label_guarantee"> </a>
              </li>
              <li>
                <a [title]="t('label_url_faq')" [routerLink]="['/', _lang, 'documents', t('label_url_faq')]" transloco="label_url_faq"></a>
              </li>
            </ul>
          </section>
          <!-- end:: Help -->
        </div>
        <!-- end:: Col-3 -->

        <!-- begin:: Col-4 -->
        <div class="col-md-2 col-xs-12">
          <!-- begin:: Advertise -->
          <section>
            <h5 class="text-white">
              <i class="fa fa-ad text-white me-2"></i>
              <span transloco="label_advertise"></span>
            </h5>
            <ul>
              <li>
                <a [title]="t('label_banner_advertising')" [routerLink]="['/', _lang, 'documents', t('label_url_banner_advertising')]" transloco="label_banner_advertising"> </a>
              </li>
              <li>
                <a [title]="t('label_subscription')" [routerLink]="['/', _lang, 'documents', t('label_url_subscription')]" transloco="label_subscription"> </a>
              </li>
            </ul>
          </section>
          <!-- end:: Advertise -->

          <!-- begin:: Features -->
          <section>
            <h5 class="text-white">
              <i class="fa fa-toolbox text-white me-2"></i>
              <span transloco="label_features"></span>
            </h5>
            <ul>
              <li>
                <a [title]="t('label_rating')" [routerLink]="['/', _lang, 'documents', t('label_url_rating')]" transloco="label_rating"> </a>
              </li>
            </ul>
          </section>
          <!-- end:: Features -->
        </div>
        <!-- end:: Col-4 -->

        <!-- begin:: Col-5 -->
        <div class="col-md-2 col-xs-12">
          <!-- begin:: About the company -->
          <section>
            <h5 class="text-white">
              <i class="fa fa-building text-white me-2"></i>
              <span transloco="label_about_the_company"></span>
            </h5>
            <ul>
              <li>
                <a [title]="t('label_about_the_company')" [routerLink]="['/', _lang, 'documents', t('label_url_about_us')]" transloco="label_about_the_company"></a>
              </li>
              <li>
                <a [title]="t('label_company_information')" [routerLink]="['/', _lang, 'documents', t('label_url_company_information')]" transloco="label_company_information"></a>
              </li>
              <li>
                <a [title]="t('label_values')" [routerLink]="['/', _lang, 'documents', t('label_url_values')]" transloco="label_values"></a>
              </li>
              <li>
                <a [title]="t('label_press_information')" [routerLink]="['/', _lang, 'documents', t('label_url_press_information')]" transloco="label_press_information"></a>
              </li>
              <li>
                <a [title]="t('label_contact')" [routerLink]="['/', _lang, 'contact-us']" transloco="label_contact"></a>
              </li>
              <li>
                <a [title]="t('label_affiliated_companies')" [routerLink]="['/', _lang, 'affiliated-companies']" transloco="label_affiliated_companies"> </a>
              </li>
            </ul>
          </section>
          <!-- end:: About the company -->
        </div>
        <!-- end:: Col-5 -->

        <!-- begin:: Col-6 -->
        <div class="col-md-2 col-xs-12">
          <!-- begin:: About the website -->
          <section>
            <h5 class="text-white">
              <i class="fa fa-globe text-white me-2"></i>
              <span transloco="label_about_the_website"></span>
            </h5>
            <ul>
              <li>
                <a [title]="t('label_about_the_website')" [routerLink]="['/', _lang, 'documents', t('label_url_about_the_website')]" transloco="label_about_the_website"></a>
              </li>
              <li>
                <a [title]="t('label_privacy_policy')" [routerLink]="['/', _lang, 'documents', t('label_url_privacy_policy')]" transloco="label_privacy_policy"></a>
              </li>
              <li>
                <a [title]="t('label_use_of_cookies')" [routerLink]="['/', _lang, 'documents', t('label_url_use_of_cookies')]" transloco="label_use_of_cookies"></a>
              </li>
              <li>
                <a [title]="t('label_terms_of_use')" [routerLink]="['/', _lang, 'documents', t('label_url_terms_of_use')]" transloco="label_terms_of_use"></a>
              </li>
              <li>
                <a [title]="t('label_accessibility')" [routerLink]="['/', _lang, 'documents', t('label_url_accessibility')]" transloco="label_accessibility"></a>
              </li>
              <li>
                <a [title]="t('label_terms_of_purchase')" [routerLink]="['/', _lang, 'documents', t('label_url_terms_of_purchase')]" transloco="label_terms_of_purchase"></a>
              </li>
              <li>
                <a [title]="t('label_sales_and_refunds')" [routerLink]="['/', _lang, 'documents', t('label_url_sales_and_refunds')]" transloco="label_sales_and_refunds"></a>
              </li>
              <li>
                <a [title]="t('label_legal_information')" [routerLink]="['/', _lang, 'documents', t('label_url_legal_information')]" transloco="label_legal_information"></a>
              </li>
              <li>
                <a [title]="t('label_sitemap')" [routerLink]="['/', _lang, 'documents', t('label_url_sitemap')]" transloco="label_sitemap"></a>
              </li>
            </ul>
          </section>
          <!-- end:: About the website -->
        </div>
        <!-- end:: Col-6 -->
      </div>
      <!-- end:: footer link -->

      <!-- begin:: copyright section -->
      <div class="row">
        <div class="col-md-6 col-xs-12 copyright text-white mt-8">
          Copyright ©
          <span>1996-{{ currentDateStr }}</span>
          |
          <span> Bildelsbasen Nordic AB</span>
          |
          <span>Version-{{ appVersion }}</span>
          | All Rights Reserved.
        </div>
      </div>
      <!-- end:: copyright section -->
    </div>
    <!-- end:: Container -->
  </ng-container>
}
